import { render, staticRenderFns } from "./awardsInfo.vue?vue&type=template&id=fa9b0aac&scoped=true&"
import script from "./awardsInfo.vue?vue&type=script&lang=js&"
export * from "./awardsInfo.vue?vue&type=script&lang=js&"
import style0 from "./awardsInfo.vue?vue&type=style&index=0&id=fa9b0aac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9b0aac",
  null
  
)

export default component.exports